export const basicFormData = () => ({
  inputData: {
    project_id: "",
    state_id: "",
    city_id: "",
    warehouse_name: "",
    type: "",
    address: "",
    is_active: true,
    created_by: null,
    updated_by: null,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "warehouse_masters",
    // whereCondition: {
    //   is_active: true,
    // },
  };

  const navigatePage = { back: "/warehouse-list" };

  const headerName = "Warehouse";

  const validationType = "WarehouseCreate";
  const createEndpoint = "/createWarehouse";
  const updateEndpoint = "/updateWarehouse";
  const getEndpoint = "/getWarehouseById";
  const dependentDropdownData = [
    {
      module_name: "state_masters",
      initialPayload: {
        modelName: "state_masters",
        whereCondition: {
          is_active: true,
        },
      },
      isOtherDependentOnThis: true,
      patchFieldName: "state_name",
      dropdownDataValue: "state_id",
      endPoint: "/listState",
    },
    {
      module_name: "city_masters",
      initialPayload: {
        modelName: "city_masters",
      },
      isOtherDependentOnThis: false,
      isDepenetOn: "city_masters",
      patchFieldName: "city_name",
      dropdownDataValue: "city_id",
      endPoint: "/listCity",
    },
  ];
  const warehouseTypeList = [
    {
      options: [
        { label: "Bermad", value: "1" },
        { label: "Contractor", value: "2" },
      ],
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
    warehouseTypeList,
  };
};

export const listPageData = (type) => {
  const payload = {
    modelName: "warehouse_masters",
    whereCondition: {
      type: type,
    },

    relations: [
      {
        module: "state_masters",
        moduleAs: "state",
      },
      {
        module: "city_masters",
        moduleAs: "city",
      },
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
      {
        module: "projects",
        moduleAs: "project",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Project Name", value: "project.project_name" },
    { label: "State Name", value: "state.state_name" },
    { label: "City Name", value: "city.city_name" },
    { label: "Warehouse Name", value: "warehouse_name" },
    { label: "Warehouse Type", value: "type" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/warehouse-create",
    edit: "/warehouse-create",
    view: "/warehouse-view",
  };

  const searchfields = [
    "warehouse_name",
    "state.state_name",
    "city.city_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "Warehouse";
  const endpoint = "/listWarehouse";
  const exportFileName = "warehouseData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,

    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "warehouse_masters",
  relations: [
    {
      module: "state_masters",
      moduleAs: "state",
    },
    {
      module: "city_masters",
      moduleAs: "city",
    },
    {
      module: "user_masters",
      moduleAs: "createdBy",
    },
    {
      module: "user_masters",
      moduleAs: "updatedBy",
    },
    {
      module: "projects",
      moduleAs: "project",
    },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
